// answerReason.ts — a reason beside a non-full answer (DESIGN_SLICE_ANSWER_REASON
// 291026 V1.0). Kenneth, 2026-10-28: "we need drop down lists or free texts to
// give answers to why we dont meet the criteria ... we have built it but
// delivery organization refuses to use the process".
//
// The reason is the respondent's own words, stored in the criterion response's
// existing `rationale` column (class C, the N/A reason's home), as one string.
// Free text only since DESIGN_SLICE_REASON_FREE_TEXT 011126 V1.0: the first
// respondent picked "Other" for 15 of 17 reasons and wrote the reason in the
// text, so the pick-list is gone (Kenneth, 2026-11-01, "Free text only"). A
// reason saved with a pick-list label ("Other — …") stays as it was stored and
// is edited as one text; nothing is parsed on the way in or out.

/** A reason line is offered for every answer below the scale's top level. */
export function offersReason(score: number | null, maxScore: number): boolean {
  return score !== null && score < maxScore;
}

/** The one stored string, or null when the respondent gave nothing. */
export function storedReason(text: string): string | null {
  return text.trim() || null;
}
